import * as React from "react";
import { Link } from "gatsby";
import { usePageContext } from "@/contexts/Page";
import "./index.scss";
interface PageLogoTypes {
  color?: string;
}

export const PageLogo: React.FC<PageLogoTypes> = ({ color = "white" }) => {
  const { title, language, type, content } = usePageContext();
  const generateLink = (path: string) => {
    return language === "es" ? path : `/en${path}`;
  };
  return (
    <Link title="Inicio" className="page-logo" to={generateLink("/")}>
      <span className={`logo color__${color}`}></span>
      {type === "template" && content === "Location" ? (
        <ul className="nav-list">
          <li>{title}</li>
        </ul>
      ) : (
        <></>
      )}
    </Link>
  );
};
